import { createTheme } from '@mui/material/styles';

export default function getTheme(userTheme){
    const basePalette = {
        primary: {
            light: '#2d7cff',
            main: '#1f6feb',
            dark: '#0f355e',
            contrastText: '#e7edf7',
        },
        secondary: {
            light: '#1d2f4d',
            main: '#15263f',
            dark: '#0f1e33',
            contrastText: '#e7edf7',
        },
    };
    
    switch(userTheme){
        case "LionstoothEnergy":
            return(createTheme({ palette: basePalette }));
        default:
            return(createTheme({ palette: basePalette }));
    }
    
}
